module.exports = __webpack_public_path__ + "static/media/logo-color.120c294f.svg";